import React from "react";
import { Link } from "react-router-dom";
import { Gift, Instagram, MessageCircle } from "lucide-react";
import { useInstagram, useSettings } from "@/context/SettingsContext";
import { useContent } from "@/lib/content";

export const Footer = () => {
  const ig = useInstagram();
  const settings = useSettings();
  const content = useContent();
  const wa = String(settings?.whatsapp_number || "").replace(/\D/g, "");
  const waHref = wa ? `https://wa.me/${wa}` : null;
  return (
  <footer className="relative mt-10 border-t border-border bg-wp-surface">
    <div className="wp-container grid gap-8 py-12 sm:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="flex items-center gap-2.5">
          <img src="/logo.jpg" alt="Wonder Parcel" className="h-11 w-11 rounded-full object-cover ring-1 ring-wp-beige-200" />
          <span className="flex flex-col leading-none">
            <span className="font-display text-lg leading-none tracking-[0.01em] text-wp-rose-strong">Wonder</span>
            <span className="wp-label mt-0.5 text-[11px] leading-none tracking-[0.2em] text-wp-ink-muted">Parcel</span>
          </span>
        </div>
        <p className="mt-3 max-w-xs text-sm text-wp-ink-muted" data-testid="footer-brand-copy">{content.footer_brand_copy}</p>
        <div className="mt-4 flex gap-2">
          <a href={ig.url} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="grid h-10 w-10 place-items-center rounded-full bg-white shadow-wp-soft text-wp-rose-strong hover:scale-105 transition-transform"><Instagram className="h-5 w-5" /></a>
          {waHref && <a href={waHref} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="grid h-10 w-10 place-items-center rounded-full bg-white shadow-wp-soft text-wp-success hover:scale-105 transition-transform"><MessageCircle className="h-5 w-5" /></a>}
        </div>
      </div>
      <div>
        <p className="wp-label text-xs text-wp-rose-strong">Shop</p>
        <ul className="mt-3 space-y-2 text-sm text-wp-ink-muted">
          <li><Link to="/shop" className="hover:text-wp-rose-strong">Explore Gifts</Link></li>
          <li><Link to="/build" className="hover:text-wp-rose-strong">Build Your Parcel</Link></li>
          <li><Link to="/custom-silver" data-testid="footer-silver-link" className="hover:text-wp-rose-strong">Custom Silver Gifts</Link></li>
          <li><Link to="/founder" className="hover:text-wp-rose-strong">Founder Collection</Link></li>
          <li><Link to="/shop?budget=under-599" className="hover:text-wp-rose-strong">Under ₹599</Link></li>
        </ul>
      </div>
      <div>
        <p className="wp-label text-xs text-wp-rose-strong">Company</p>
        <ul className="mt-3 space-y-2 text-sm text-wp-ink-muted">
          <li><Link to="/our-story" className="hover:text-wp-rose-strong">Our Story</Link></li>
          <li><Link to="/corporate-gifting" data-testid="footer-corporate-link" className="hover:text-wp-rose-strong">Corporate Gifting</Link></li>
          <li><Link to="/track" className="hover:text-wp-rose-strong">Track Order</Link></li>
          <li><Link to="/contact" className="hover:text-wp-rose-strong">Contact</Link></li>
          <li><Link to="/reminders" className="hover:text-wp-rose-strong">Occasion Reminders</Link></li>
        </ul>
      </div>
      <div>
        <p className="wp-label text-xs text-wp-rose-strong">Help</p>
        <ul className="mt-3 space-y-2 text-sm text-wp-ink-muted">
          <li><Link to="/contact#faq" className="hover:text-wp-rose-strong">FAQs</Link></li>
          <li><Link to="/contact" className="hover:text-wp-rose-strong">Contact Us</Link></li>
          {waHref && <li><a href={waHref} target="_blank" rel="noreferrer" className="hover:text-wp-rose-strong">WhatsApp Support</a></li>}
          <li><a href={ig.url} target="_blank" rel="noreferrer" className="hover:text-wp-rose-strong">Instagram {ig.handle}</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-border">
      <div className="wp-container flex flex-col items-center justify-between gap-2 py-5 text-xs text-wp-ink-muted sm:flex-row">
        <p>© {new Date().getFullYear()} Wonder Parcel. Made with 💝 for little everyday joys.</p>
        <p>Meaningful Keepsakes · Curated Gift Parcels</p>
      </div>
    </div>
  </footer>
  );
};
